import { BottomBanner, NotFound } from '@chiroup/components';
import { useScript } from '@chiroup/hooks';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Container from './components/Container';

const PAY_JS_URL = import.meta.env.VITE_PAY_JS_URL as string;

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const queryClient = new QueryClient();

function App() {
  const scriptStatus = useScript(PAY_JS_URL, {
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (scriptStatus === 'ready') {
      // Monkey patch the payJS object to update the addEventListner function
      (window as any).usaepay.PaymentCard.prototype.addEventListener =
        function (eventType: any, response: any) {
          const paymentCardiFrame =
            document.getElementById('paymentCardIFrame');

          function messageListener(event: any) {
            if (event.source === (paymentCardiFrame as any)?.contentWindow) {
              const msg = event.data.split('::');
              if (msg[0] === eventType) {
                response(msg[1]);
              }
            }
          }

          // Add the event listener
          window.addEventListener('message', messageListener);

          // Cleanup: Remove the event listener when the component unmounts
          return function cleanup() {
            window.removeEventListener('message', messageListener);
          };
        };
    } else if (scriptStatus === 'error') {
      // Handle script loading error here if needed.
      console.error('Failed to load useepay script.');
    }
  }, [scriptStatus]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SentryRoutes>
          <Route path="/:path/*" element={<Container />} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </BrowserRouter>
      {import.meta.env.VITE_STAGE === 'sandbox' && (
        <BottomBanner message="You are in sandbox mode. Do not use real data." />
      )}
    </QueryClientProvider>
  );
}

export default App;
